import { SPECIALTY_VALUE } from "../MarketPlace";

export interface TestimonialsDataItem {
  id: string;
  content: string;
  date: string;
  author: string;
}

const getTestimonialsData = (specialtyValue: SPECIALTY_VALUE) => {
  switch (specialtyValue) {
    case "Therapist":
      return [
        {
          id: "therapist-0",
          content:
            "My therapist hears me wholly, turning empathy into healing paths. I feel validated and deeply understood in every session. A true listener!",
          date: "September 25, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "therapist-1",
          content:
            "Persistent and attentive, he recalls every detail, ensuring each appointment builds on the last. He challenges and supports with resources that truly make a difference.",
          date: "October 02, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "therapist-2",
          content:
            "Revolutionized my life! Learned all about CBT, and now I have new hope. I am grateful to Orchid and to my therapist for the match!",
          date: "August 14, 2023",
          author: "Verified Orchid Client",
        },
      ];
    case "Psychologist":
      return [
        {
          id: "psychologist-0",
          content:
            "Every session translates my feelings into a healing path, offering validation and profound understanding. Stress-management strategies were not only shared but also tailored to my exact needs.",
          date: "September 02, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "psychologist-1",
          content:
            "Transformative care in navigating grief. Their compassionate approach allowed me to explore and heal my emotional pain securely.",
          date: "September 15, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "psychologist-2",
          content:
            "Revived our relationship! Was hesitant about couples therapy but we were provided with tools to navigate through our struggles, and it's like our second honeymoon!",
          date: "September 30, 2023",
          author: "Verified Orchid Client",
        },
      ];
    case "Psychiatry":
      return [
        {
          id: "psychiatry-0",
          content:
            "Managing my prescription has been really hard in the past, but the whole med thing is now simple and stress-free. I feel super cared for and seeing my doc is painless.",
          date: "September 02, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "psychiatry-1",
          content:
            "My doctor switched systems, and I felt everything in my care--from scheduling to texting--became so much easier. Even though my doctor is great, I think the tech they use is also important in the healing process!",
          date: "September 15, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "psychiatry-2",
          content:
            "In recovery and found the perfect support group. Our psych curated a space for true collective healing and understanding, and I've become more at ease with my past and with who I am today.",
          date: "September 30, 2023",
          author: "Verified Orchid Client",
        },
      ];
    default: {
      return [
        {
          id: "default-0",
          content:
            "My therapist hears me wholly, turning empathy into healing paths. I feel validated and deeply understood in every session. A true listener!",
          date: "September 25, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "default-1",
          content:
            "Persistent and attentive, he recalls every detail, ensuring each appointment builds on the last. He challenges and supports with resources that truly make a difference.",
          date: "October 02, 2023",
          author: "Verified Orchid Client",
        },
        {
          id: "default-2",
          content:
            "Managing my prescription has been really hard in the past, but the whole med thing is now simple and stress-free. I feel super cared for and seeing my doc is painless.",
          date: "September 12, 2023",
          author: "Verified Orchid Client",
        },
      ];
    }
  }
};

export default getTestimonialsData;
